import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { Form, Badge } from "react-bootstrap";
import { FaChartBar, FaCertificate } from "react-icons/fa";
import { timeSince } from "utils/utiuls";
import ApiGServer from "services/ApiGServer";
import { useTheme } from "../../../contexts/ThemeContext";
import { KPI, CHART_GRADIENTS, getChartTextColor } from "constants/dashboardColors";
import "./CertificadoDash.css";

const CertificadoDash = () => {
  const [equipments, setEquipments] = useState([]);
  const [certificadoLabels, setCertificadoLabels] = useState([]);
  const [certificadoDataset, setCertificadoDataset] = useState([]);
  const [checkLocacao, setCheckLocacao] = useState(false);
  const [certEmDia, setCertEmDia] = useState("");
  const [certAtraso, setCertAtraso] = useState("");
  const [loading, setLoading] = useState(true);
  const { darkMode } = useTheme();
  const theme = darkMode ? 'dark' : 'light';

  const processData = (equipments, loc) => {

    let equipamentos = [...equipments];

    if (loc) {
      equipamentos = equipamentos.filter(i => i.mode == "RENTAL")
    }

    const sampleArray = [];
    for (let index = 0; index < equipamentos.length; index++) {
      const element = equipamentos[index];

      var strData = element.dcal;
      if (strData) {
        var d = new Date(strData);

        let time = timeSince(d);

        sampleArray.push(time);
      } else {
        sampleArray.push("NaN");
      }
    }

    setCertEmDia(sampleArray.filter(i => i.includes("mês") || i.includes("meses")).length)
    setCertAtraso(sampleArray.filter(i => i.includes("ano") || i.includes("anos")).length)

    const counts = {};

    sampleArray.forEach((x) => { counts[x] = (counts[x] || 0) + 1; });

    var result = [];

    const keys = Object.keys(counts);

    keys.forEach((key, index) => {
      result.push(`${key}: ${counts[key]}`);
    });

    let meses = result.filter(i => i.includes("mês") || i.includes("meses")).sort((a, b) => { return a.split(" ")[0] - b.split(" ")[0] })
    let anos = result.filter(i => i.includes("ano") || i.includes("anos")).sort((a, b) => { return a.split(" ")[0] - b.split(" ")[0] })
    let finalArray = meses.concat(anos);

    let dataset = finalArray.map(i => i.split(":")[1]);
    setCertificadoDataset(dataset);
    let labels = finalArray.map(i => i.split(":")[0]);
    setCertificadoLabels(labels);
  }

  useEffect(() => {
    const getData = async () => {
      try {
        setLoading(true);
        const { data } = await ApiGServer.get('/equipment/all');
        setEquipments(data);
        processData(data, false);
      } catch (error) {
        console.error('Erro ao carregar dados:', error);
      } finally {
        setLoading(false);
      }
    }
    getData();
  }, []);

  const chartTextColor = getChartTextColor(theme === 'dark');

  const getBarGradient = (ctx) => {
    const gradient = ctx.createLinearGradient(0, 0, 0, 400);
    const primary = CHART_GRADIENTS.primary;
    const secondary = CHART_GRADIENTS.secondary;
    gradient.addColorStop(0, theme === 'dark' ? primary.dark : primary.light);
    gradient.addColorStop(1, theme === 'dark' ? secondary.dark : secondary.light);
    return gradient;
  };

  const getChartOptions = () => ({
    maintainAspectRatio: false,
    responsive: true,
    layout: {
      padding: {
        top: 10,
        right: 10,
        bottom: 40,
        left: 10
      }
    },
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        backgroundColor: theme === 'dark' ? 'rgba(33, 37, 41, 0.95)' : 'rgba(255, 255, 255, 0.95)',
        titleColor: theme === 'dark' ? '#fff' : '#333',
        bodyColor: theme === 'dark' ? '#adb5bd' : '#666',
        borderColor: theme === 'dark' ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.1)',
        borderWidth: 1,
        cornerRadius: 8,
        titleFont: {
          weight: '600'
        },
        bodyFont: {
          weight: '400'
        },
        padding: 12
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          color: chartTextColor,
          font: {
            family: 'Inter, system-ui, sans-serif',
            size: 12
          },
          padding: 8
        },
        grid: {
          color: theme === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)',
          borderColor: theme === 'dark' ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.1)'
        }
      },
      x: {
        ticks: {
          color: chartTextColor,
          font: {
            family: 'Inter, system-ui, sans-serif',
            size: 11
          },
          maxRotation: 45,
          minRotation: 0,
          padding: 8
        },
        grid: {
          display: false
        }
      }
    },
    animation: {
      duration: 1000,
      easing: 'easeInOutQuart'
    }
  });

  return (
    <div className="certificado-dashboard">
      <div className="certificado-header">
        <div>
          <h4 className="certificado-title">
            <FaCertificate className="me-2" />
            Certificados de Calibração
          </h4>
          <p className="certificado-subtitle">
            Acompanhe o status dos certificados dos equipamentos
          </p>
          
          <div className="certificado-badges">
            <Badge className="certificado-badge bg-success">
              <span className="fw-normal">Em dia:</span>
              <span className="ms-2 fw-bold">{certEmDia}</span>
            </Badge>
            <Badge className="certificado-badge bg-danger">
              <span className="fw-normal">Em atraso:</span>
              <span className="ms-2 fw-bold">{certAtraso}</span>
            </Badge>
          </div>
        </div>

        <div className="certificado-switch-container">
          <Form.Check
            type="switch"
            id="locacao-switch"
            label="Apenas Locação"
            checked={checkLocacao}
            onChange={() => {
              setCheckLocacao(!checkLocacao)
              processData(equipments, !checkLocacao)
            }}
            className="certificado-switch"
          />
        </div>
      </div>

      <div className="certificado-chart-container" style={{ height: '450px' }}>
        {loading ? (
          <div className="certificado-loading">
            <div className="d-flex flex-column align-items-center">
              <div className="spinner mb-3"></div>
              <span>Carregando dados...</span>
            </div>
          </div>
        ) : (
          <>
            <div className="d-flex align-items-center mb-3">
              <FaChartBar className="me-2 text-success" />
              <span className="fw-semibold" style={{ color: 'var(--brand-dark-green)' }}>
                Distribuição por Período
              </span>
            </div>
            <Bar
              data={{
                labels: certificadoLabels,
                datasets: [
                  {
                    label: 'Equipamentos',
                    data: certificadoDataset,
                    backgroundColor: (context) => {
                      const { chart } = context;
                      const { ctx } = chart;
                      return getBarGradient(ctx);
                    },
                    borderColor: KPI.primary,
                    borderWidth: 2,
                    borderRadius: 6,
                    borderSkipped: false,
                    barThickness: 28,
                    maxBarThickness: 40,
                    hoverBackgroundColor: KPI.secondary,
                    hoverBorderColor: KPI.primary,
                    hoverBorderWidth: 3
                  }
                ]
              }}
              options={getChartOptions()}
            />
          </>
        )}
      </div>
    </div>
  )
}

export default CertificadoDash;
